import { render, staticRenderFns } from "./TeacherHeaderNavigation.vue?vue&type=template&id=1239e9c9&"
import script from "./TeacherHeaderNavigation.vue?vue&type=script&lang=ts&"
export * from "./TeacherHeaderNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports